(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  class TdFaqTabs extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handleHashChange = this.handleHashChange.bind(this);

      this.addEventListener('click', this.handleClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      window.addEventListener('hashchange', this.handleHashChange);

      this.openFromHash();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      window.removeEventListener('hashchange', this.handleHashChange);
    }

    handleHashChange() {
      this.openFromHash();
    }

    tabFromHash(hash) {
      const wanted = TdFaqTabs.slug(decodeURIComponent(String(hash || '').replace(/^#/, '')));
      if (!wanted) return null;

      return (
        [...this.querySelectorAll('[data-td-tab-trigger]')].find(
          (trigger) => TdFaqTabs.anchorFor(trigger) === wanted
        ) || null
      );
    }

    static anchorFor(trigger) {
      return TdFaqTabs.slug(trigger.dataset.tdTabAnchor) || TdFaqTabs.slug(trigger.dataset.tdTabBlock);
    }

    static slug(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/^tab[-_]/, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    syncHash(trigger) {
      const slug = TdFaqTabs.anchorFor(trigger);
      if (!slug || typeof window.history?.replaceState !== 'function') return;

      const { pathname, search } = window.location;
      window.history.replaceState(window.history.state, '', `${pathname}${search}#${slug}`);
    }

    openFromHash() {
      const trigger = this.tabFromHash(window.location.hash);
      if (!trigger) return false;

      this.activateTab(trigger.dataset.tdTabTarget);
      return true;
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-td-tab-trigger]');
      if (!trigger || !this.contains(trigger)) return;

      this.activateTab(trigger.dataset.tdTabTarget);
      this.syncHash(trigger);
    }

    handleBlockSelect(event) {
      const panel = event.target.closest('[data-td-tab-panel]');
      if (!panel || !this.contains(panel)) return;

      const trigger = this.querySelector(`[data-td-tab-trigger][data-td-tab-block="${CSS.escape(panel.dataset.tdTabBlock)}"]`);
      if (trigger) this.activateTab(trigger.dataset.tdTabTarget);
    }

    handleBlockDeselect() {}

    activateTab(targetId) {
      this.querySelectorAll('[data-td-tab-trigger]').forEach((trigger) => {
        const isActive = trigger.dataset.tdTabTarget === targetId;
        trigger.classList.toggle('td-faq-tabs__tab--active', isActive);
        trigger.setAttribute('aria-selected', String(isActive));
      });

      this.querySelectorAll('[data-td-tab-panel]').forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });
    }
  }

  if (!customElements.get('td-faq-tabs')) {
    customElements.define('td-faq-tabs', TdFaqTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-quiz"] && !Shopify.designMode) return;
  try {
    
  const TD_QUIZ_SELECTORS = Object.freeze({
    ariaInvalid: '[aria-invalid="true"]',
    back: '[data-td-quiz-back]',
    email: '[data-td-quiz-email]',
    emailConsent: '[data-td-quiz-email-consent]',
    error: '[data-td-quiz-error]',
    focusHeading: '[tabindex="-1"]',
    form: '[data-td-quiz-form]',
    greeting: '[data-td-quiz-greeting]',
    name: '[data-td-quiz-name]',
    next: '[data-td-quiz-next]',
    noResult: '[data-td-quiz-no-result]',
    privacyConsent: '[data-td-quiz-privacy-consent]',
    progress: '[data-td-quiz-progress]',
    progressLabel: '[data-td-quiz-progress-label]',
    progressValue: '[data-td-quiz-progress-value]',
    result: '[data-td-quiz-result]',
    resultHeading: '[data-td-result-heading]',
    resultLinkContext: '[data-td-result-link-context]',
    results: '[data-td-quiz-results]',
    selectedRadio: 'input[type="radio"]:checked',
    step: '[data-td-quiz-step]',
  });

  /** Controls the Key product recommendation assessment flow. */
  class TdProductQuiz extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.navigationStack = [];
      this.greetingTimer = null;
      this.handleClick = this.handleClick.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    /**
     * Initializes quiz state and event listeners.
     * @returns {void}
     */
    connectedCallback() {
      if (this.isConnectedToQuiz) return;

      this.form = this.querySelector(TD_QUIZ_SELECTORS.form);
      this.steps = Array.from(this.querySelectorAll(TD_QUIZ_SELECTORS.step));
      this.results = Array.from(this.querySelectorAll(TD_QUIZ_SELECTORS.result));
      this.resultsContainer = this.querySelector(TD_QUIZ_SELECTORS.results);
      this.progress = this.querySelector(TD_QUIZ_SELECTORS.progress);

      if (!this.form || !this.steps.length || !this.resultsContainer) return;

      this.isConnectedToQuiz = true;
      this.addEventListener('click', this.handleClick);
      this.addEventListener('change', this.handleChange);
      this.addEventListener('keydown', this.handleKeydown);
      this.form.addEventListener('submit', this.handleSubmit);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.showStep(0, false, false);
    }

    /**
     * Removes all component listeners and pending timers.
     * @returns {void}
     */
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('change', this.handleChange);
      this.removeEventListener('keydown', this.handleKeydown);
      this.form?.removeEventListener('submit', this.handleSubmit);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      window.clearTimeout(this.greetingTimer);
      this.isConnectedToQuiz = false;
    }

    /**
     * Prevents native form submission while the quiz controls its own flow.
     * @param {SubmitEvent} event - Form submission event.
     * @returns {void}
     */
    handleSubmit(event) {
      event.preventDefault();
    }

    /**
     * Handles delegated next and back button clicks.
     * @param {MouseEvent} event - Component click event.
     * @returns {void}
     */
    handleClick(event) {
      const backButton = event.target.closest(TD_QUIZ_SELECTORS.back);
      if (backButton && this.contains(backButton)) {
        this.goBack();
        return;
      }

      const nextButton = event.target.closest(TD_QUIZ_SELECTORS.next);
      if (!nextButton || !this.contains(nextButton)) return;

      if (nextButton.dataset.tdQuizNext === 'name') {
        this.advanceFromName();
      } else if (nextButton.dataset.tdQuizNext === 'email') {
        this.advanceFromEmail();
      }
    }

    /**
     * Records input changes and advances radio questions.
     * @param {Event} event - Component change event.
     * @returns {void}
     */
    handleChange(event) {
      if (!event.target.matches('input')) return;

      const step = event.target.closest(TD_QUIZ_SELECTORS.step);
      this.clearError(step);

      if (event.target.type === 'radio') {
        this.advance();
      }
    }

    /**
     * Uses Escape as a keyboard shortcut for Back.
     * @param {KeyboardEvent} event - Component keyboard event.
     * @returns {void}
     */
    handleKeydown(event) {
      if (event.key === 'Escape' && this.navigationStack.length) {
        event.preventDefault();
        this.goBack();
      }
    }

    /**
     * Reveals a selected quiz block in the Shopify editor.
     * @param {CustomEvent} event - Shopify block selection event.
     * @returns {void}
     */
    handleBlockSelect(event) {
      const selectedBlock = event.target;
      if (!(selectedBlock instanceof Element) || !this.contains(selectedBlock)) return;

      const step = selectedBlock.closest(TD_QUIZ_SELECTORS.step);
      if (step) {
        const index = this.steps.indexOf(step);
        if (index >= 0) this.showStep(index, false, false);
        return;
      }

      const result = selectedBlock.closest(TD_QUIZ_SELECTORS.result);
      if (!result) return;

      this.hideSteps();
      this.resultsContainer.hidden = false;
      this.results.forEach((item) => {
        item.hidden = item !== result;
        item.classList.remove('td-quiz__result--secondary');
      });
    }

    /**
     * Validates the name and privacy consent before starting.
     * @returns {void}
     */
    advanceFromName() {
      const step = this.steps[this.currentIndex];
      const nameInput = step.querySelector(TD_QUIZ_SELECTORS.name);
      const consentInput = step.querySelector(TD_QUIZ_SELECTORS.privacyConsent);

      if (!nameInput.value.trim()) {
        this.showError(step, this.dataset.tdNameRequiredMessage, nameInput);
        return;
      }

      if (!consentInput.checked) {
        this.showError(step, this.dataset.tdConsentRequiredMessage, consentInput);
        return;
      }

      const greeting = this.querySelector(TD_QUIZ_SELECTORS.greeting);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      step.hidden = true;
      step.classList.remove('td-quiz__step--active');
      greeting.textContent = this.dataset.tdGreetingTemplate.replace('[name]', nameInput.value.trim());
      greeting.hidden = false;

      window.clearTimeout(this.greetingTimer);
      this.greetingTimer = window.setTimeout(() => {
        greeting.hidden = true;
        this.advance();
      }, reducedMotion ? 0 : 900);
    }

    /**
     * Validates the email step before continuing.
     * @returns {void}
     */
    advanceFromEmail() {
      const step = this.steps[this.currentIndex];
      const emailInput = step.querySelector(TD_QUIZ_SELECTORS.email);

      if (!emailInput.checkValidity()) {
        this.showError(step, this.dataset.tdEmailInvalidMessage, emailInput);
        return;
      }

      this.advance();
    }

    /**
     * Resolves branching and activates the next step or results.
     * @returns {void}
     */
    advance() {
      const currentStep = this.steps[this.currentIndex];
      let nextIndex = this.currentIndex + 1;
      const branchType = currentStep.dataset.tdBranchType;

      if (branchType && branchType !== 'none') {
        const score = this.calculateScore(currentStep.dataset.tdBranchGroup);
        const threshold = Number(currentStep.dataset.tdBranchThreshold);
        const branchMatches = branchType === 'less' ? score < threshold : score > threshold;

        if (branchMatches) nextIndex = Number(currentStep.dataset.tdBranchTarget);
      }

      if (nextIndex >= this.steps.length) {
        this.navigationStack.push(this.currentIndex);
        this.showResults();
        return;
      }

      this.showStep(nextIndex, true, true);
    }

    /**
     * Activates one quiz step and updates its progress state.
     * @param {number} index - Zero-based step index.
     * @param {boolean} addToHistory - Whether to retain the current step for Back.
     * @param {boolean} focusHeading - Whether to move focus to the next heading.
     * @returns {void}
     */
    showStep(index, addToHistory = true, focusHeading = true) {
      if (!this.steps[index]) return;

      if (addToHistory && index !== this.currentIndex) {
        this.navigationStack.push(this.currentIndex);
      }

      this.resultsContainer.hidden = true;
      this.results.forEach((result) => {
        result.hidden = true;
        result.classList.remove('td-quiz__result--secondary');
      });

      this.steps.forEach((step, stepIndex) => {
        const isActive = stepIndex === index;
        step.hidden = !isActive;
        step.toggleAttribute('data-td-active', isActive);
        step.classList.toggle('td-quiz__step--active', isActive);
      });

      this.currentIndex = index;
      this.updateProgress();

      if (focusHeading) {
        window.requestAnimationFrame(() => this.steps[index].querySelector(TD_QUIZ_SELECTORS.focusHeading)?.focus());
      }
    }

    /**
     * Hides every question and the progress indicator.
     * @returns {void}
     */
    hideSteps() {
      this.steps.forEach((step) => {
        step.hidden = true;
        step.removeAttribute('data-td-active');
        step.classList.remove('td-quiz__step--active');
      });
      this.progress.hidden = true;
    }

    /**
     * Returns to the last visited step.
     * @returns {void}
     */
    goBack() {
      window.clearTimeout(this.greetingTimer);
      this.querySelector(TD_QUIZ_SELECTORS.greeting).hidden = true;
      const previousIndex = this.navigationStack.pop();
      if (previousIndex === undefined) return;
      this.showStep(previousIndex, false, true);
    }

    /**
     * Synchronizes visual and announced progress.
     * @returns {void}
     */
    updateProgress() {
      const showProgress = this.currentIndex > 0;
      const progressValue = this.querySelector(TD_QUIZ_SELECTORS.progressValue);
      const progressLabel = this.querySelector(TD_QUIZ_SELECTORS.progressLabel);
      const lastIndex = Math.max(this.steps.length - 1, 1);
      const percentage = Math.round((this.currentIndex / lastIndex) * 100);

      this.progress.hidden = !showProgress;
      this.style.setProperty('--td-quiz-progress', `${percentage}%`);
      progressValue.setAttribute('aria-valuenow', String(percentage));
      progressLabel.textContent = this.dataset.tdProgressTemplate.replace('[percentage]', String(percentage));
    }

    /**
     * Totals selected answers assigned to a scoring group.
     * @param {string} group - Score group identifier.
     * @returns {number} The selected-answer total.
     */
    calculateScore(group) {
      if (!group) return 0;

      return this.steps.reduce((total, step) => {
        const groups = (step.dataset.tdScoreGroups || '').split(',').map((item) => item.trim());
        if (!groups.includes(group)) return total;

        const selectedChoice = step.querySelector(TD_QUIZ_SELECTORS.selectedRadio);
        return total + (selectedChoice ? Number(selectedChoice.dataset.tdScore) : 0);
      }, 0);
    }

    /**
     * Reveals matching recommendations and submits completed results.
     * @returns {void}
     */
    showResults() {
      this.hideSteps();
      this.resultsContainer.hidden = false;
      const matchedResults = this.results.filter((result) => {
        const score = this.calculateScore(result.dataset.tdScoreGroup);
        return score >= Number(result.dataset.tdScoreFloor) && score <= Number(result.dataset.tdScoreCeiling);
      });

      this.results.forEach((result) => {
        const matchIndex = matchedResults.indexOf(result);
        const isMatched = matchIndex >= 0;
        result.hidden = !isMatched;
        result.classList.toggle('td-quiz__result--secondary', matchIndex > 0);

        if (isMatched) {
          const headingText = matchIndex === 0 ? result.dataset.tdPrimaryHeading : result.dataset.tdSecondaryHeading;
          const heading = result.querySelector(TD_QUIZ_SELECTORS.resultHeading);
          const linkContext = result.querySelector(TD_QUIZ_SELECTORS.resultLinkContext);
          if (heading) heading.textContent = headingText;
          if (linkContext) linkContext.textContent = ` - ${headingText}`;
        }
      });

      const noResult = this.querySelector(TD_QUIZ_SELECTORS.noResult);
      noResult.hidden = matchedResults.length > 0;
      const firstHeading =
        matchedResults[0]?.querySelector(TD_QUIZ_SELECTORS.resultHeading) ||
        noResult.querySelector(TD_QUIZ_SELECTORS.focusHeading);
      window.requestAnimationFrame(() => firstHeading?.focus());

      if (matchedResults.length) {
        this.trackResults(matchedResults);
        this.submitResults(matchedResults);
      }
    }

    /**
     * Sends consented recommendation events to Klaviyo when available.
     * @param {HTMLElement[]} matchedResults - Visible recommendation elements.
     * @returns {void}
     */
    trackResults(matchedResults) {
      const emailInput = this.querySelector(TD_QUIZ_SELECTORS.email);
      const emailConsent = this.querySelector(TD_QUIZ_SELECTORS.emailConsent);
      if (!emailConsent?.checked || !emailInput?.value || !window.klaviyo) return;

      const recommendations = matchedResults.map((result) => result.dataset.tdResultKey);
      window.klaviyo.identify({'email': emailInput.value});
      window.klaviyo.push(['track', 'quiz_results', recommendations]);
    }

    /**
     * Posts the completed response to the configured results endpoint.
     * @param {HTMLElement[]} matchedResults - Visible recommendation elements.
     * @returns {void}
     */
    submitResults(matchedResults) {
      const endpoint = this.dataset.tdResultsEndpoint;
      if (!endpoint) return;

      const formData = new FormData();
      formData.append('name', this.querySelector(TD_QUIZ_SELECTORS.name)?.value || '');
      formData.append('email', this.querySelector(TD_QUIZ_SELECTORS.email)?.value || '');

      this.steps.forEach((step) => {
        const selectedChoice = step.querySelector(TD_QUIZ_SELECTORS.selectedRadio);
        if (selectedChoice && step.dataset.tdQuizQuestionId) {
          formData.append(step.dataset.tdQuizQuestionId, selectedChoice.value);
        }
      });

      matchedResults.forEach((result, index) => {
        formData.append(`recommendation-${index}`, result.dataset.tdResultKey);
      });

      fetch(endpoint, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      }).catch((error) => console.error('Quiz results could not be submitted.', error));
    }

    /**
     * Announces a validation error and focuses its input.
     * @param {HTMLElement} step - Active step element.
     * @param {string} message - User-facing validation message.
     * @param {HTMLInputElement} input - Invalid input element.
     * @returns {void}
     */
    showError(step, message, input) {
      const error = step.querySelector(TD_QUIZ_SELECTORS.error);
      error.textContent = message;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }

    /**
     * Clears validation state from a step after input changes.
     * @param {HTMLElement|null} step - Step containing the changed input.
     * @returns {void}
     */
    clearError(step) {
      if (!step) return;
      const error = step.querySelector(TD_QUIZ_SELECTORS.error);
      if (error) error.textContent = '';
      step.querySelectorAll(TD_QUIZ_SELECTORS.ariaInvalid).forEach((input) => input.removeAttribute('aria-invalid'));
    }
  }

  if (!customElements.get('td-product-quiz')) {
    customElements.define('td-product-quiz', TdProductQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
